import {toast} from 'react-toastify';
import React from "react";

type propType = {
    title:string,
    message?:string
    autoClose?:number
}
const ToastMessage = ({ title, message }   :propType) => (
    <div>
        <strong>{title}</strong>
        {message &&
            <div>{message}</div>
        }
    </div>
);



// const notifications = useAppSelector(state => state.notifications);
//
// const [alertModal, setAlertModal] = useState("")
// useEffect(() => {
//     let noti = ((notifications ?? []) as {title:string}[])[0]?.title;
//     if(noti?.includes("agotado")){
//         setAlertModal(noti)
//     }
// }, [notifications, setAlertModal]);

// <ConfirmDialog
//     title={"Plan"}
//     primaryBtnText={"Ver Planes"}
//     open={!!alertModal}
//     mode={"warning"}
//     onClose={()=> {
//         setAlertModal("")
//     }}
//     onConfirm={()=> {
//         setAlertModal("")
//         Dispatch(togglePaypalPlan())
//     }}
// >
//     <DialogContentText>
//         {alertModal}
//     </DialogContentText>
// </ConfirmDialog>



const notify = {
    success: ({ title, message, autoClose }   :propType) => {
        return toast(<ToastMessage title={title} message={message} />, { type: 'success', autoClose:autoClose??3000, hideProgressBar: true });
    },
    error: ({ title, message, autoClose }   :propType) => {
        return toast(<ToastMessage title={title} message={message} />, { type: 'error', autoClose:autoClose??3000, hideProgressBar: true });
    },
    info: ({ title, message, autoClose }   :propType) => {
        return toast(<ToastMessage title={title} message={message} />, { type: 'info', autoClose:autoClose??3000, hideProgressBar: true});
    },
    warning: ({ title, message, autoClose }   :propType) => {
        return toast(<ToastMessage title={title} message={message} />, { type: 'warning', autoClose:autoClose??3000, hideProgressBar: true });
    },
};

export default notify;
